var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4962_63502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9 25.95C20.0245 25.95 25.8 20.1409 25.8 12.975C25.8 5.8091 20.0245 0 12.9 0C5.77553 0 0 5.8091 0 12.975C0 20.1409 5.77553 25.95 12.9 25.95Z",
    fill: "url(#paint0_linear_4962_63502)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9289 20.95C17.3079 20.95 20.8578 17.3795 20.8578 12.975C20.8578 8.57053 17.3079 5 12.9289 5C8.54989 5 5 8.57053 5 12.975C5 17.3795 8.54989 20.95 12.9289 20.95Z",
    fill: "url(#paint1_linear_4962_63502)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4962_63502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.02 29.9399C27.5154 29.928 27.0358 29.7178 26.685 29.3549L23.685 25.785C23.368 25.4978 23.1776 25.0968 23.1551 24.6697C23.1326 24.2426 23.28 23.8239 23.565 23.505V23.505C23.844 23.239 24.2146 23.0907 24.6 23.0907C24.9854 23.0907 25.356 23.239 25.635 23.505L29.475 26.505C29.7454 26.7833 29.9301 27.1333 30.0072 27.5136C30.0844 27.8939 30.0506 28.2883 29.91 28.65C29.7722 29.0125 29.5311 29.3266 29.2164 29.5532C28.9018 29.7799 28.5275 29.9091 28.14 29.9249L28.02 29.9399Z",
    fill: "url(#paint2_linear_4962_63502)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4962_63502",
    x: 0,
    y: 0,
    width: 25.7998,
    height: 27.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4962_63502"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4962_63502",
    x: 23.1528,
    y: 23.0907,
    width: 6.89502,
    height: 8.84924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4962_63502"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4962_63502",
    x1: -1.94107,
    y1: -26.469,
    x2: 31.4911,
    y2: -24.7556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4962_63502",
    x1: 12.9289,
    y1: 20.95,
    x2: 12.9289,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4962_63502",
    x1: 22.6341,
    y1: 16.1045,
    x2: 31.5679,
    y2: 16.5681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.90343ce6bff4bac53403284392bb254a.svg";
export { ForwardRef as ReactComponent };